import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe to return the string name of an enum value.
 * Usage: {{ status | enumName:TestStatus }}
 */
@Pipe({
  name: 'enumName',
  standalone: false,
})
export class EnumNamePipe implements PipeTransform {
  transform(value: number | string, enumType: any): string {
    if (enumType === undefined) {
      return value.toString();
    }

    return enumType[value] ?? value.toString();
  }
}
